export default "__VITE_ASSET__NxQ382wX__"